import type {
  ViewAlphaQuoteInput,
  ViewAlphaQuoteResponse,
} from '@snap-types/actions/view-alpha-quote';
import { AUTO_CONFIGURATOR_SLICE_NAME } from '@ui/constants/auto-configurator';
import { buildSiteUrl } from '@ui/store/api-builder/build-url';
import { injectQuery } from '@ui/store/api-builder/inject-query';

export const [viewAlphaQuote, useViewAlphaQuoteQuery] = injectQuery<
  ViewAlphaQuoteInput,
  ViewAlphaQuoteResponse
>(
  `${AUTO_CONFIGURATOR_SLICE_NAME}/viewAlphaQuote`,
  ({ siteCode, alphaQuoteUuid, snapQuoteUuid }) => ({
    url: buildSiteUrl(
      siteCode,
      `auto-configurator/alpha/${alphaQuoteUuid}/snap-quotes/${snapQuoteUuid}`,
    ),
  }),
);
